import { Field, FieldGroup, FieldLabel, FieldLegend, FieldSet } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { NewbornScreeningConfiguration } from './newbornScreening';
const blank: NewbornScreeningConfiguration = {
  cchd: {
    enabled: false,
    clinically_reviewed: false,
    citation: 'AAP 2025 CCHD clinical report',
    algorithm: 'AAP_2025',
  },
  ballard: {
    enabled: false,
    clinically_reviewed: false,
    citation: 'New Ballard Score, 1991',
    algorithm: 'NEW_BALLARD_1991',
  },
};
export function NewbornScreeningConfigEditor({
  value,
  onChange,
}: {
  value?: NewbornScreeningConfiguration;
  onChange: (v: NewbornScreeningConfiguration) => void;
}) {
  const current = value ?? blank;
  return (
    <FieldSet>
      <FieldLegend>Newborn screening interpretation</FieldLegend>
      <p>Assessment entry remains available without automated interpretation. Enable only after practice review.</p>
      <FieldGroup>
        {(['cchd', 'ballard'] as const).map((key) => (
          <FieldSet key={key}>
            <FieldLegend>{key === 'cchd' ? 'CCHD · AAP 2025' : 'New Ballard · numeric score'}</FieldLegend>
            <FieldGroup>
              <Field>
                <FieldLabel>Interpretation</FieldLabel>
                <Select
                  value={current[key].enabled ? 'reviewed' : 'off'}
                  onValueChange={(v) =>
                    onChange({
                      ...current,
                      [key]: { ...current[key], enabled: v === 'reviewed', clinically_reviewed: v === 'reviewed' },
                    })
                  }>
                  <SelectTrigger aria-label={`${key} interpretation`}>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="off">Off</SelectItem>
                      <SelectItem value="reviewed">Reviewed for this practice and enabled</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </Field>
              <Field>
                <FieldLabel>Reference / review source</FieldLabel>
                <Input
                  aria-label={`${key} source`}
                  value={current[key].citation}
                  onChange={(e) => onChange({ ...current, [key]: { ...current[key], citation: e.target.value } })}
                />
              </Field>
            </FieldGroup>
          </FieldSet>
        ))}
      </FieldGroup>
    </FieldSet>
  );
}
